import React from "react"
import { Query } from "react-apollo"
import gql from "graphql-tag"
import { Redirect } from "react-router"

const findShortenedURL = gql`
  query findShortenedURL($id: String!) {
    findShortenedURL(id: $id) {
      id
      slug
    }
  }
`

const URL = (props) => {
  const { params } = props.match
  if (!props.viewer || !props.viewer.isUserAuthenticated) {
    return (
      <Redirect
        to={{ pathname: "/login", state: { from: `/url/${params.slug}` } }}
      />
    )
  }

  return (
    <Query
      fetchPolicy={"network-only"}
      query={findShortenedURL}
      variables={{ id: params.slug }}
    >
      {({ loading, error, data }) => {
        if (loading) return "Redirecting..."
        if (error) {
          return <Redirect to="/not-found" />
        }
        if (data && data.findShortenedURL) {
          return <Redirect to={data.findShortenedURL.slug} />
        }
        return <Redirect to="/not-found" />
      }}
    </Query>
  )
}

export default URL
